import { Layout } from "antd";
import { useEffect, useState } from "react";
import FullPageLoader from "../../Common/PageLoader";
import HeaderComponent from "../../Layout/HeaderComponent";
import LeftSidebar from "../../Layout/LeftSidebar";
import ManageDoctor from "../ManageDoctor";
import { Route, Routes } from "react-router-dom";
import { getData } from "../../utils";
import { useNavigate } from "react-router-dom";
import AdminPrivateRoutes from "../../RouteHandler/AdminPrivateRoutes";
import ManageDiscountCodes from "../ManageDiscountCodes";
import ManageInstitutes from "../ManageInstitutes";

const { Content } = Layout;

const Default = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true); // State for loading status
  const [error, setError] = useState(null); // State for error handling
    const navigate = useNavigate()
  const toggleSidebar = (collapsedState) => {
    setCollapsed(collapsedState);
  };

  const fetchAdmin = async () => {
    try {
      setLoading(true); // Set loading state
      const response = await getData("/v1/admin/profile", true);
      setAdmin(response.data); // Store the response in the state
      setLoading(false); // Reset loading state
    } catch (err) {
      console.error("Failed to fetch admin profile:", err);
      setLoading(false); // Reset loading state
      setError(err.response?.data?.message); // Store error message in the state
      navigate('/')
    }
  };

  useEffect(() => {
    if(localStorage.getItem('token') !== null){
      fetchAdmin();
      navigate('/admin/doctors');
    } 
    
  }, []); // Empty dependency array ensures this runs only once on mount


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <LeftSidebar collapsed={collapsed} toggleCollapsed={toggleSidebar} />
      <Layout>
        <HeaderComponent toggleCollapsed={toggleSidebar} name={`${admin?.firstName} ${admin?.lastName}`}/>
        <Content style={{ margin: "16px 16px" }}>
          {loading && <FullPageLoader />} {/* Display loading state */}
          {error && <div>Error: {error}</div>} {/* Display error if any */}
          <Routes>
            {/* Dashboard Route */}
            <Route path="/" element={<AdminPrivateRoutes />} >
              <Route path="/admin/doctors" element={<ManageDoctor />} />
              <Route path="/admin/manage-coupons" element={<ManageDiscountCodes/>}/>
              <Route path="/admin/manage-institutes" element={<ManageInstitutes/>}/>
            </Route>
            
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Default;
